<script>
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import { XIcon } from 'vue-feather-icons'
import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  components: { XIcon },
  extends: BaseModal,
  mounted() {
    eventBus.$emit('refresh-token-via-websockets')
  }
}
</script>

<template lang="pug">
span
  .modal-body
    p {{ data.message }}
    .text-right(v-if="!data.buttonCancel")
      button.btn.btn-primary.btn(type="button" v-ea-click="() => { close(true) }") {{ data.button || $t('done') }}
    .d-flex.justify-content-between(v-else)
      button.btn.btn-danger.btn(type="button" v-ea-click="() => { close() }") {{ data.buttonCancel || $t('cancel') }}
      button.btn.btn-primary.btn(type="button" v-ea-click="() => { close(true) }") {{ data.buttonConfirm || $t('done') }}
</template>

<style lang="scss" scoped>
.modal-body {
  font-size: 2rem;
}
button {
  padding: 0.5rem 1rem;
  font-size: 2rem;
  border-radius: 1rem;
  text-transform: uppercase;
}
</style>
